/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OverwatchMapTripAnnotationsQueryVariables = Types.Exact<{
  tripId?: Types.InputMaybe<Types.Scalars['String']['input']>
  vtrId?: Types.InputMaybe<Types.Scalars['String']['input']>
}>

export type OverwatchMapTripAnnotationsQuery = {
  __typename?: 'Query'
  tripAnnotations: Array<{
    __typename?: 'TripAnnotation'
    annotationId: string
    recordedAtMs: number
    vehicleId: string
    driverId: string
    severity: Types.TripAnnotationSeverity
    tripId: string | null
    vtrId: string | null
    transcriptionStatus: Types.TripAnnotationTranscriptionStatus
    transcript: string | null
    audioS3Uri: string
    location: {
      __typename?: 'TripGeolocation'
      latitude: number
      longitude: number
    }
  }>
}

export const OverwatchMapTripAnnotationsDocument = gql`
    query OverwatchMapTripAnnotations($tripId: String, $vtrId: String) {
  tripAnnotations(tripId: $tripId, vtrId: $vtrId) {
    annotationId
    recordedAtMs
    vehicleId
    driverId
    severity
    location {
      latitude
      longitude
    }
    tripId
    vtrId
    transcriptionStatus
    transcript
    audioS3Uri
  }
}
    `

/**
 * __useOverwatchMapTripAnnotationsQuery__
 *
 * To run a query within a React component, call `useOverwatchMapTripAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverwatchMapTripAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverwatchMapTripAnnotationsQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      vtrId: // value for 'vtrId'
 *   },
 * });
 */
export function useOverwatchMapTripAnnotationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >(OverwatchMapTripAnnotationsDocument, options)
}
export function useOverwatchMapTripAnnotationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >(OverwatchMapTripAnnotationsDocument, options)
}
// @ts-ignore
export function useOverwatchMapTripAnnotationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapTripAnnotationsQuery,
  OverwatchMapTripAnnotationsQueryVariables
>
export function useOverwatchMapTripAnnotationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapTripAnnotationsQuery,
        OverwatchMapTripAnnotationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapTripAnnotationsQuery | undefined,
  OverwatchMapTripAnnotationsQueryVariables
>
export function useOverwatchMapTripAnnotationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapTripAnnotationsQuery,
        OverwatchMapTripAnnotationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OverwatchMapTripAnnotationsQuery,
    OverwatchMapTripAnnotationsQueryVariables
  >(OverwatchMapTripAnnotationsDocument, options)
}
export type OverwatchMapTripAnnotationsQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationsQuery
>
export type OverwatchMapTripAnnotationsLazyQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationsLazyQuery
>
export type OverwatchMapTripAnnotationsSuspenseQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationsSuspenseQuery
>
export type OverwatchMapTripAnnotationsQueryResult = Apollo.QueryResult<
  OverwatchMapTripAnnotationsQuery,
  OverwatchMapTripAnnotationsQueryVariables
>
